var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOceanConservation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Water-Protection-Fish--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Water Protection Fish Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 15.62a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 1 0 -2.5 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 3a3.71 3.71 0 0 1 -3.05 -1.72 0.52 0.52 0 0 0 -0.9 0A4 4 0 0 1 16 3a4 4 0 0 1 -3.55 -1.72 0.52 0.52 0 0 0 -0.9 0A4 4 0 0 1 8 3a4 4 0 0 1 -3.55 -1.72 0.52 0.52 0 0 0 -0.9 0A3.71 3.71 0 0 1 0.5 3a0.5 0.5 0 0 0 -0.5 0.5v20a0.5 0.5 0 0 0 0.5 0.5h23a0.5 0.5 0 0 0 0.5 -0.5v-20a0.5 0.5 0 0 0 -0.5 -0.5ZM19 16.25c0 1 -2.69 4.09 -6.47 4.09a8.44 8.44 0 0 1 -5.84 -2.88 0.51 0.51 0 0 0 -0.66 -0.07l-1.44 1.07a1 1 0 0 1 -0.59 0.19 0.91 0.91 0 0 1 -0.45 -0.11 1 1 0 0 1 -0.55 -0.89v-2.8a1 1 0 0 1 0.55 -0.85 1 1 0 0 1 1 0.08l1.46 1.07a0.5 0.5 0 0 0 0.66 -0.06 8.57 8.57 0 0 1 5.84 -2.88c3.78 0 6.46 3.09 6.47 4.08Zm-0.27 -3.75a0.75 0.75 0 1 1 0.75 -0.75 0.76 0.76 0 0 1 -0.73 0.75ZM20 10a2 2 0 1 1 2 -2 2 2 0 0 1 -2 2Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOceanConservation);
export default ForwardRef;